/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Browser(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M216.0006,40H40.00721a16.018,16.018,0,0,0-15.9994,16V95.84521C24.00684,95.89746,24,95.94775,24,96s.00684.10254.00781.15479V200a16.018,16.018,0,0,0,15.9994,16H216.0006A16.018,16.018,0,0,0,232,200V56A16.018,16.018,0,0,0,216.0006,40Zm0,16,.002,32H40.00721V56Z" />
    </Svg>
  );
}

export default Browser;
